import getConfig from 'next/config';
import { BreadcrumbItem } from '../components/Breadcrumbs/BreadcrumbContainer';
import { CityStateCountry } from '../services/geo-info';
import { formatSearchString } from './formatting';
import { SeoListType } from '../types/seo-list-type';

const { publicRuntimeConfig } = getConfig();

const getLocationBreadcrumbs = (
  location: CityStateCountry,
  trade?: SeoListType,
  classification?: SeoListType
): BreadcrumbItem[] => {
  const result: BreadcrumbItem[] = [];
  let url = publicRuntimeConfig.basePath;
  if (location?.country) {
    url += `/${location.country.alpha2.toLowerCase()}`;
    result.push({
      name: location.country.preferredName || location.country.name,
      url,
    });
  }
  if (location?.state) {
    url += `/${location.state.abbreviation.toLowerCase()}`;
    result.push({ name: location.state.name, url });
  }
  if (location?.city) {
    url += `/${formatSearchString(location.city, '-')}`;
    result.push({ name: location.city, url });
  }
  if (trade) {
    url += `/${trade.urlKey}`;
    result.push({ name: trade.label, url });
  }
  if (classification) {
    url += `/${classification.urlKey}`;
    result.push({ name: classification.label, url });
  }

  return result;
};

export { getLocationBreadcrumbs };
